import { useEffect } from "react";

// Shown in every footer: Google Ads verification needs the brand on the landing page tied to the legal entity.
export const LEGAL_LINE = "ArtOfResume is a brand owned and operated by Bharat Reborn Private Limited, Jhansi, Uttar Pradesh, India.";
export const CONTACT_EMAIL = "rakesh@bharatreborn.com";

const host = () => window.location.hostname.replace(/^www\./, "");
export const isMainHost = () => host() === "artofresume.com";

// The main site lives at "/" on artofresume.com and at "/site" everywhere else (go. subdomain, preview)
export const siteHome = () => (isMainHost() ? "/" : "/site");

// The funnel lives at "/go" on every host (and also at "/" on non-main hosts)
export const funnelHref = (path = "/") => path.replace(/^\/(?=[#?]|$)/, "/go");

export const useSiteChrome = (title) => {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "/aor-assets/aor.css";
    link.dataset.aorSite = "1";
    document.head.appendChild(link);
    document.documentElement.classList.add("aor-site");
    const prevTitle = document.title;
    document.title = title;
    return () => {
      link.remove();
      document.documentElement.classList.remove("aor-site");
      document.title = prevTitle;
    };
  }, [title]);
};
